module.exports = __webpack_public_path__ + "img/vol05_cup01_badge.936e10fb.png";